import { Controller } from "@hotwired/stimulus"

export default class CoreuiOtpInputControlController extends Controller {
  static outlets = ["coreui-otp-input"]

  clear() {
    this.coreuiOtpInputOutlets.forEach((owner) => owner.clear())
  }
}
